// Report Center personalization — favorites + recently-run, kept in
// localStorage (per browser). Server-side saved definitions arrive in R3.

const FAVORITES_KEY = 'kp_reports_favorites';
const RECENTS_KEY = 'kp_reports_recents';
const MAX_RECENTS = 6;

export interface RecentRun {
  id: string; // template id
  at: string; // ISO timestamp
}

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota — personalization is best-effort */
  }
}

export function getFavorites(): string[] {
  const v = read<string[]>(FAVORITES_KEY, []);
  return Array.isArray(v) ? v : [];
}

export function toggleFavorite(templateId: string): string[] {
  const cur = getFavorites();
  const next = cur.includes(templateId) ? cur.filter((id) => id !== templateId) : [...cur, templateId];
  write(FAVORITES_KEY, next);
  return next;
}

export function getRecents(): RecentRun[] {
  const v = read<RecentRun[]>(RECENTS_KEY, []);
  return Array.isArray(v) ? v.filter((r) => r && typeof r.id === 'string') : [];
}

export function recordRecent(templateId: string): RecentRun[] {
  const next: RecentRun[] = [
    { id: templateId, at: new Date().toISOString() },
    ...getRecents().filter((r) => r.id !== templateId),
  ].slice(0, MAX_RECENTS);
  write(RECENTS_KEY, next);
  return next;
}
